import Transform from '@ember-data/serializer/transform';

export default class HtmlTransform extends Transform {
  serialize() {
    console.log('HtmlTransform', ...arguments);
  }
  deserialize(serialized) {
    // TODO: sanitize HTML if necessary
    return serialized;
  }
}
